import React from 'react'
import { Container, Row, Col, Card } from "react-bootstrap";
import {
  CodeSlash,
  Globe, LockFill ,
  Diagram3,
  MortarboardFill,
  CheckCircleFill,
} from "react-bootstrap-icons";
import "./ourservices.scss";
import ClientCount from './ClientCount';
import DemoCall from './DemoCall';

function UiplusService() {
  return (
    <>
      <section className="services-section">
      <Container className="py-5">

        {/* Section Header */}
        <div className="text-center mb-5">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle" style={{ textAlign:"justify", fontWeight: "600" }}>
            We provide end-to-end software solutions designed to simplify operations, improve efficiency, and support business growth. From custom development to ongoing support, our services are tailored to meet the unique needs of every client.
          </p>
        </div>

        <Row className="g-4">

          {/* Service 1 */}
          <Col md={6} lg={4}>
            <Card className="service-card">
              <Card.Body>
                <div className="service-icon">
                  <CodeSlash />
                </div>
                <h5 style={{ color:"blue" }}>Custom Software Development</h5>
                <p style={{ textAlign:"justify", fontWeight: "600" }}>
                  Our custom software development services help businesses automate processes, reduce manual work, and improve productivity. We analyze your workflow and build solutions that perfectly align with your operational needs.
                </p>

                <ul className="feature-list">
                  <li style={{ color:"Red", fontWeight:"bold" }}><LockFill  /> Key Features :</li>
                  <li><CheckCircleFill /> Web & desktop application development</li>
                  <li><CheckCircleFill /> ERP, CRM & business automation systems</li>
                  <li><CheckCircleFill /> Scalable architecture & secure coding</li>
                  <li><CheckCircleFill /> User-friendly interface design</li>
                </ul>

              </Card.Body>
            </Card>
          </Col>

          {/* Service 2 */}
          <Col md={6} lg={4}>
            <Card className="service-card">
              <Card.Body>
                <div className="service-icon">
                  <Globe />
                </div>
                <h5 style={{ color:"blue" }}>Web Application Development</h5>
                <p style={{ textAlign:"justify", fontWeight: "600" }}>
                  Our web solutions are designed to work seamlessly across devices and browsers, ensuring smooth user experience and optimal performance. Our products are built using modern technologies to ensure security, scalability, and high performance.
                </p>

                <ul className="feature-list">
                  <li style={{ color:"Red", fontWeight:"bold" }}><LockFill  /> Key Features :</li>
                  <li><CheckCircleFill /> Web Api, and React modern web technologies</li>
                  <li><CheckCircleFill /> Responsive & mobile-friendly design</li>
                  <li><CheckCircleFill /> Secure database integration</li>
                  <li><CheckCircleFill /> Performance optimization</li>
                </ul>

              </Card.Body>
            </Card>
          </Col>

          {/* Service 3 */}
          <Col md={6} lg={4}>
            <Card className="service-card">
              <Card.Body>
                <div className="service-icon">
                  <Diagram3 />
                </div>
                <h5 style={{ color:"blue" }}>ERP Solutions</h5>
                <p style={{ textAlign:"justify", fontWeight: "600" }}>
                  Complete ERP solutions to manage your business operations from a single platform. Our ERP systems help organizations manage accounts, inventory, HR, billing, reporting, and more—improving accuracy and decision-making.
                </p>

                <ul className="feature-list">
                  <li style={{ color:"Red", fontWeight:"bold" }}><LockFill  /> Key Features :</li>
                  <li><CheckCircleFill /> Finance & accounting modules</li>
                  <li><CheckCircleFill /> Inventory & stock management</li>
                  <li><CheckCircleFill /> HR & payroll integration</li>
                  <li><CheckCircleFill /> Custom reports & dashboards</li>
                </ul>

              </Card.Body>
            </Card>
          </Col>

          
        </Row>

      </Container>

      <ClientCount />

      <div className="row mt-5"></div>

    </section>

    <section className="services-section">
      <Container className="py-5">

        

        <Row className="g-4">

          {/* Service 1 */}
          <Col md={6} lg={4}>
            <Card className="service-card">
              <Card.Body>
                <div className="service-icon">
                  <MortarboardFill />
                </div>
                <h5 style={{ color:"blue" }}>School / Education ERP Software</h5>
                <p style={{ textAlign:"justify", fontWeight: "600" }}>
                  Smart digital solutions for efficient school and college management. 
                  Our school ERP solutions simplify administration, improve communication, and enhance transparency between management, teachers, students, and parents.
                </p>

                <ul className="feature-list">
                  <li style={{ color:"Red", fontWeight:"bold" }}><LockFill  /> Key Features :</li>
                  <li><CheckCircleFill /> Student admission & fee management</li>
                  <li><CheckCircleFill /> Attendance, exams & result management</li>
                  <li><CheckCircleFill /> Parent & teacher portals</li>
                  <li><CheckCircleFill /> SMS / email notifications</li>
                </ul>

              </Card.Body>
            </Card>
          </Col>

          {/* Service 2 */}
          <Col md={6} lg={4}>
            <Card className="service-card">
              <Card.Body>
                <div className="service-icon">
                  <Diagram3 />
                </div>
                <h5 style={{ color:"blue" }}>Finance & Accounting Software</h5>
                <p style={{ textAlign:"justify", fontWeight: "600" }}>
                  Reliable and accurate financial software for complete money management. We offer finance applications designed to handle daily transactions, reports, compliance, and audits with precision and security.
                </p>

                <ul className="feature-list">
                  <li style={{ color:"Red", fontWeight:"bold" }}><LockFill  /> Key Features :</li>
                  <li><CheckCircleFill /> Accounting, FD, loan & saving modules</li>
                  <li><CheckCircleFill /> GST & tax-ready reports</li>
                  <li><CheckCircleFill /> Secure data handling</li>
                  <li><CheckCircleFill /> Easy-to-use dashboards</li>
                </ul>

              </Card.Body>
            </Card>
          </Col>

          {/* Service 3 */}
          <Col md={6} lg={4}>
            <Card className="service-card">
              <Card.Body>
                <div className="service-icon">
                  <Diagram3 />
                </div>
                <h5 style={{ color:"blue" }}>Product Demo & Consultation</h5>
                <p style={{ textAlign:"justify", fontWeight: "600" }}>
                  Expert guidance to help you choose the right solution. We offer live product demos and consultations to understand your business needs and recommend the best solution.
                </p>

                <ul className="feature-list">
                  <li style={{ color:"Red", fontWeight:"bold" }}><LockFill  /> Key Features :</li>
                  <li><CheckCircleFill /> Free demo sessions</li>
                  <li><CheckCircleFill /> Requirement analysis</li>
                  <li><CheckCircleFill /> Solution customization guidance</li>
                  <li><CheckCircleFill /> Transparent pricing discussion</li>
                </ul>

              </Card.Body>
            </Card>
          </Col>

          
        </Row>

      </Container>

      

    </section>

    <DemoCall />

    </>
  )
}

export default UiplusService
